/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Edge } from "./Edge";
import { SourceField } from "./SourceField";
import { DestinationField } from "./DestinationField";
export const JobExecutionPlan = core.serialization.object({
    fieldMapping: core.serialization.list(Edge),
    unmappedSourceFields: core.serialization.list(SourceField),
    unmappedDestinationFields: core.serialization.list(DestinationField),
    programId: core.serialization.string().optional(),
});
